<script setup>
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
// import LucideSpinner from "~icons/lucide/loader-2";
// import GitHubLogo from "~icons/radix-icons/github-logo";

import { supabase } from '@/lib/supabaseClient'

import { loadScript } from '@/lib/utils/loadScript.js'

const route = useRoute()

const loading = ref(false)
const completedEmailSignup = ref(false) // Ref to track email signup completion
const email = ref('')

async function handleLogin() {
  try {
    loading.value = true
    // alert(email.value);
    const { error } = await supabase.auth.signInWithOtp(
      {
        email: email.value,
      },
      {
        redirectTo: window.location.origin,
      },
    )
    if (error)
      throw error
    //  if (error) throw error;
    completedEmailSignup.value = true // Show "check your email" message

    // alert("Check your email for the login link!");
  }
  catch (error) {
    if (error instanceof Error) {
      console.log(error)
      alert(error.message)
    }
  }
  finally {
    loading.value = false
  }
}

/*
import { Button } from "@/lib/registry/new-york/ui/button";
import { Input } from "@/lib/registry/new-york/ui/input";
import { Label } from "@/lib/registry/new-york/ui/label";
*/

async function handleSignInWithGoogle(response) {
  loading.value = true
  console.log(response)
  const { data, error } = await supabase.auth.signInWithIdToken({
    provider: 'google',
    token: response.credential,
  })
  loading.value = false
  console.log(data)
  if (error) {
    console.error(error)
    alert(error.message)
  }
  //  alert("done auth!");
}

window.handleSignInWithGoogle = handleSignInWithGoogle // expose globally for goog.

const shouldShowLoginWithGooglePopup = computed(() => {
  return route.name === 'home' || route.path === '/'
})

onMounted(async () => {
  // Only load Google Sign-In on the home/root page
  //  if (route.name === "home" || route.path === "/" || true) {
  try {
    await loadScript('https://accounts.google.com/gsi/client')
    console.log('Google Sign-In script loaded successfully')
    // You can initialize Google Sign-In functionality here
  }
  catch (error) {
    console.error(error.message)
  }
  // }
})
</script>

<template>
  <!-- Fullscreen message after email signup -->
  <div
    v-if="completedEmailSignup"
    class="fixed inset-0 flex items-center justify-center z-50"
    style="background: darkseagreen"
  >
    <div class="text-center">
      <p class="text-2xl mb-4">
        Nous avons envoyé un courriel à
        {{ email }}. Vérifiez votre boîte de réception pour vous connecter.
      </p>
      <button class="text-xl" @click="completedEmailSignup = false">
        <icon icon="mdi:close" class="text-3xl" />
      </button>
    </div>
  </div>

  <!-- Scrim for loading state -->
  <div
    v-if="loading"
    class="fixed inset-0 bg-opacity-50 z-40 flex items-center justify-center"
    style="background: #888"
  >
    <div class="text-lg">
      Chargement...
    </div>
  </div>

  <!-- Form content -->

  <div class="container mx-auto p-4">
    <form class="grid gap-6" @submit.prevent="handleLogin">
      <div />
      <div class="grid gap-2">
        <Input
          v-model="email"
          class="inputField border p-2"
          required
          type="email"
          placeholder="Votre courriel"
          :disabled="loading"
          name="email"
        />
        <Button
          :disabled="loading"
          class="btn px-4 py-2"
          @click.native="handleLogin"
        >
          {{ loading ? "Chargement..." : "Envoyer le lien" }}
        </Button>
      </div>
    </form>

    <div class="relative mt-6">
      <div class="absolute inset-0 flex items-center">
        <span class="w-full border-t" />
      </div>
      <div class="relative flex justify-center text-xs uppercase">
        <span class="px-2 mb-6 mt-6"> Ou continuez avec </span>
      </div>
    </div>
    <!-- You can add your GitHub OAuth logic here -->

    <!-- -->
    <div class="socialAuth">
      <div
        v-show="shouldShowLoginWithGooglePopup"
        id="g_id_onload"
        data-client_id="536601814961-vfeoht26arujkomjqi57mbv5bnksfrho.apps.googleusercontent.com"
        data-context="use"
        data-ux_mode="popup"
        data-callback="handleSignInWithGoogle"
        data-auto_select="true"
        data-close_on_tap_outside="false"
        data-itp_support="true"
      />

      <div
        class="g_id_signin"
        data-type="standard"
        data-shape="rectangular"
        data-theme="outline"
        data-text="continue_with"
        data-size="large"
        data-logo_alignment="left"
      />
    </div>
  </div>
</template>
